const Legend = () => (
  <div
    className="absolute bottom-auto left-5 top-32 z-10 rounded bg-[#171717]/80 p-4 sm:bottom-4 sm:top-auto md:bottom-10"
    style={{ minWidth: "173px" }}
  >
    <div className="mb-2 text-sm uppercase text-white">Shade</div>
    <div className="flex items-center">
      <span className="mr-2 text-xs text-white">0</span>
      <div
        className="h-4 flex-grow"
        style={{
          background: "linear-gradient(to left, #47505F, #8B929E, #C2CAD4, #F6D0B1)",
        }}
      />
      <span className="ml-2 text-xs text-white">&#8250;50%</span>
    </div>
  </div>
)

export default Legend
